import React from 'react';
import PropTypes from 'prop-types';

import {Card, CardContent, CardActions, Button, Typography} from 'views/components';
import {ThumbUpOffAltOutlined, ThumbDownOffAltOutlined} from 'views/icons';
import {Translate} from 'views/module';

const WasHelpfulCard = (props) => {
  const {isHelpful, onHelpful, onNotHelpful} = props;

  return (
    <Card>
      <CardContent>
        <Typography variant='body1' fontWeight={500}>
          <Translate expression={'dashboard.sections.info.wasHelpful'}/>
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          variant={isHelpful ? 'contained' : 'outlined'}
          onClick={onHelpful}
          disableElevation
          disableRipple
        >
          <ThumbUpOffAltOutlined sx={{mr: 1}}/>
          <Translate expression={'dashboard.sections.info.yes'}/>
        </Button>
        <Button
          variant={isHelpful === false ? 'contained' : 'outlined'}
          onClick={onNotHelpful}
          disableElevation
          disableRipple
        >
          <ThumbDownOffAltOutlined sx={{mr: 1}}/>
          <Translate expression={'dashboard.sections.info.no'}/>
        </Button>
      </CardActions>
    </Card>
  );
};

WasHelpfulCard.propTypes = {
  isHelpful: PropTypes.bool,
  onHelpful: PropTypes.func.isRequired,
  onNotHelpful: PropTypes.func.isRequired,
};

export default WasHelpfulCard;
